import { defineMessages } from 'react-intl';

export default defineMessages({
    totPerErrorMsg: {
        id: 'quoteandbind.PPLProLinedirectives.templates.TypesofProjects.Total Percentage Error Message',
        defaultMessage: 'Total Percentage of all projects should be equal to 100'
    }
});
